import React from "react";
import { Card, CardContent } from "@/components/ui/card";
export default function MySuperLetter() {
  return <section data-section-id="223663" id="our-philosophy" className="dark bg-background text-foreground relative flex min-h-screen items-center justify-center overflow-hidden py-24 px-4 sm:px-6 lg:px-8">
      {}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-[20%] -left-[10%] h-[70vw] w-[70vw] rounded-full bg-chart-2/10 blur-[100px] mix-blend-screen animate-pulse" style={{
        animationDuration: '8s'
      }} />
        <div className="absolute -bottom-[20%] -right-[10%] h-[70vw] w-[70vw] rounded-full bg-chart-3/10 blur-[100px] mix-blend-screen animate-pulse" style={{
        animationDuration: '12s',
        animationDelay: '2s'
      }} />
      </div>

      {}
      <Card className="relative z-10 w-full max-w-4xl border-l-4 border-l-chart-2 border-t-transparent border-r-transparent border-b-transparent bg-background/95 backdrop-blur-md shadow-md overflow-hidden rounded-sm">
        
        {}
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none opacity-[0.05] text-chart-2">
          <svg viewBox="0 0 100 100" fill="currentColor" className="w-[80%] h-[80%] max-h-full">
            <path d="M50 5 L95 25 L50 95 L5 25 Z" />
            <path d="M80 28 L50 15 L20 28 L50 80 Z" fill="var(--background)" />
            <path d="M70 32 C 40 20, 25 45, 50 55 C 75 65, 60 85, 30 75" fill="none" stroke="currentColor" strokeWidth="8" strokeLinecap="round" />
          </svg>
        </div>

        <CardContent className="p-8 sm:p-12 md:p-16 lg:p-20 relative z-20">
          <div className="prose prose-invert max-w-none">
            <p className="font-default text-lg sm:text-xl md:text-2xl leading-loose text-foreground/90 tracking-wide">
              <span className="float-left text-7xl sm:text-8xl md:text-9xl font-default text-chart-2 pr-4 pt-2 sm:pt-4 leading-none drop-shadow-md">
                A
              </span>
              t Durango Dog Massage, our philosophy is defined by the Three Pillars of Care: Clinical Precision, Restorative Recovery, and Performance Support. Founded by Jessica Gade, DPT, CSMT, we provide a sophisticated approach to canine bodywork that mirrors the highest standards of human physical therapy. Our evidence-based practice is designed specifically for the trail-tested dogs of Durango, focusing on mobility support for seniors and recovery for active athletes. We believe every dog deserves to move without pain and rest with ease. By combining medical insight with a deep understanding of canine biomechanics, we create a professional environment dedicated to your dog's longevity. Whether recovering from a high-altitude hike or managing the challenges of age, we are here to support your dog's journey toward lifelong wellness.
            </p>
          </div>
        </CardContent>
      </Card>
    </section>;
}